import Transformation from './transformation';

/**
 * select columns
 * - columnSelectorProp
 *   [
 *     {
 *       "name":
 *       "tooltip":
 *     },
 *     ...
 *   ]
 */
export default class ColumnselectorTransformation extends Transformation {
  constructor(config, columnSelectorProp) {
    super(config);
    this.props = columnSelectorProp;
  }

  getSetting() {
    let self = this;
    let configObj = self.config;
    return {
      template: 'app/tabledata/columnselector_settings.html',
      scope: {
        config: self.config,
        props: self.props,
        tableDataColumns: self.tableDataColumns,
        save: function() {
          self.emitConfig(configObj);
        },
        remove: function(selectorName) {
          configObj[selectorName] = null;
          self.emitConfig(configObj);
        },
      },
    };
  }

  /**
   * Method will be invoked when tableData or config changes
   */
  transform(tableData) {
    this.tableDataColumns = tableData.columns;
    this.removeUnknown();
    return tableData;
  }

  removeUnknown() {
    let fields = this.config;
    for (let f in fields) {
      if (fields[f]) {
        let found = false;
        for (let i = 0; i < this.tableDataColumns.length; i++) {
          let a = fields[f];
          let b = this.tableDataColumns[i];
          if (a.index === b.index && a.name === b.name) {
            found = true;
            break;
          }
        }
        if (!found && (fields[f] instanceof Object) && !(fields[f] instanceof Array)) {
          fields[f] = null;
        }
      }
    }
  }
}
